<template>
  <SubNavCardVue :buttons="buttons" />
</template>

<script>
import SubNavCardVue from "../../components/cards/SubNavCard.vue";

export default {
  components: { SubNavCardVue },
  data() {
    return {
      buttons: [
        {
          label: "Envoyer notification PDA",
          icon: "bi bi-bell-fill",
          route: "notifications-send",
        },
      ],
    };
  },
};
</script>
